import Flex from 'antd-mobile/lib/flex';
export default Flex;



// WEBPACK FOOTER //
// ./components/flex/index.tsx